import { ArrowUpRight } from "lucide-react";

const cols = [
  {
    title: "Ürünler",
    items: ["Panel & Örgü Çit", "Modern Bahçe Kapısı", "Ferforje Kapı", "Endüstriyel Sistemler"],
  },
  {
    title: "Kurumsal",
    items: ["Hakkımızda", "Ekibimiz", "Referanslar", "Sertifikalar"],
  },
  {
    title: "Destek",
    items: ["İletişim", "Teklif Al", "KVKK", "Çerez Politikası"],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-[#FF5A00] grid place-items-center rounded-xl shadow-[0_6px_18px_-6px_rgba(255,90,0,0.7)]">
                <span className="font-display text-white text-lg font-bold">İ</span>
              </div>
              <div className="leading-tight">
                <div className="font-display text-base font-semibold tracking-tight">
                  İnci Tel
                </div>
                <div className="font-mono-disp text-[10px] uppercase tracking-wider text-white/55 -mt-0.5">
                  Çit Sistemleri
                </div>
              </div>
            </div>
            <p className="font-body mt-6 text-sm text-white/60 max-w-sm leading-relaxed">
              1998&apos;den bu yana endüstriyel tel ve çit sistemleri üretiminde
              Türkiye&apos;nin güvenilir markalarından biriyiz.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 font-mono-disp text-[10px] text-[#FF5A00] font-medium">
              <span className="w-1.5 h-1.5 bg-[#FF5A00] rounded-full animate-pulse" />
              Üretim hatları aktif
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="font-display text-sm font-semibold text-white tracking-tight">
                {c.title}
              </div>
              <ul className="mt-4 space-y-2.5">
                {c.items.map((it) => (
                  <li key={it}>
                    <a
                      href="#"
                      className="group inline-flex items-center gap-1 font-body text-sm text-white/65 hover:text-[#FF5A00] transition-colors"
                    >
                      {it}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <div className="font-display text-sm font-semibold text-white tracking-tight">
              İletişim
            </div>
            <ul className="mt-4 space-y-2.5 font-body text-sm text-white/65">
              <li>
                <a
                  href="tel:+905313185280"
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  +90 531 318 52 80
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@incicitsistemleri.com.tr"
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  info@incicitsistemleri.com.tr
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-body text-xs text-white/55">
            © {year} İnci Tel Çit Sistemleri — Tüm hakları saklıdır.
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5">
            <div className="font-mono-disp text-[10px] uppercase tracking-wider text-white/45">
              İkitelli OSB / İstanbul — Türkiye
            </div>
            <a
              href="https://yazilimciordek.com.tr"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="site-credit"
              className="group font-mono-disp text-[10px] uppercase tracking-wider text-white/45 hover:text-[#FF5A00] transition-colors inline-flex items-center gap-1.5"
            >
              <span>Site Yapımcısı:</span>
              <span className="text-white/80 group-hover:text-[#FF5A00] font-semibold">
                yazilimciordek.com.tr
              </span>
              <ArrowUpRight className="w-3 h-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
